import { type IResultAnalytics, type IResultAnalyticsStats } from '../../../interface/state/IResultAnalytics';
import { resultAnalyticsType } from '../../types';
import { deleteByIdAPI, getAPI, getByIdAPI } from '../api-utils';

export const get = getAPI<IResultAnalytics>({
	actionType: resultAnalyticsType.get,
	url: '/api/v1/ResultAnalytics',
	type: 'core',
});

export const checkEntity = getAPI<IResultAnalytics>({
	actionType: resultAnalyticsType.checkEntity,
	url: '/api/v1/ResultAnalytics',
	type: 'core',
});

export const deleteById = deleteByIdAPI({
	actionType: resultAnalyticsType.deleteById,
	url: '/api/v1/ResultAnalytics',
});

export const getStats = getByIdAPI<IResultAnalyticsStats>({
	actionType: resultAnalyticsType.getStats,
	url: '/get-stats',
});
